import { useContext, useState } from "react"
import { Button, IconGoogle } from "../../../components/atoms"
import { InputGroup } from "../../../components/molecules"
import { AuthContext } from "../../../contexts/Auth/AuthContext"
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext"
import { api } from "../../../helpers"

export function DescancelarReserva() {
  const { applicationData } = useContext(AuthContext)
  const [campoObrigatorioReserva, setcampoObrigatorioReserva] =
    useState<boolean>(false)
  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const [reserva, setReserva] = useState("")

  const baixar = async () => {
    let usuario = applicationData.funcionario
    const response = await api.post(
      "/api/reserva/descancelarreserva",
      {
        reserva,
        usuario
      },
      {
        headers: { Authorization: `Bearer ${applicationData.token}` }
      }
    )
    if (response.status === 200) {
      setType("success")
      setTextAlert(response.data)
      setShow(true)
    }
  }

  return (
    <div>
      <h2>Descancelar Reserva</h2>
      <div className="row mt-1">
        <div className="row mt-3"></div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Reserva a Ser Descancelada"
            id="duracao"
            type="number"
            value={reserva}
            autoComplete="off"
            onChange={(e) => {
              setReserva(e.target.value)
            }}
          />
        </div>

        <div className="row mt-3"></div>
        <div className="row mt-3"></div>

        <div className="col-sm-12 col-lg-3">
          <Button
            className="col-sm-12 col-lg-4"
            appearance="success"
            onClick={() => {
              baixar()
            }}
          >
            Descancelar Reserva<IconGoogle>manage_search</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  )
}
